<template>
  <footer class="site-footer">
    <div class="footer-main">
      <div class="footer-container">
        <!-- 左侧：机构信息 -->
        <div class="footer-info">
          <div class="footer-logo-row">
            <span class="footer-logo-text">重慶市蘭臺檔案研究院</span>
            <span class="footer-logo-text footer-logo-en">CHONGQING MUNICIPAL LANTAI ARCHIVES</span>
            <span class="footer-logo-text footer-logo-en">RESEARCH INSTITUTE</span>
          </div>
          <div class="footer-contact">
            <p>地址：重庆市两江新区同茂大道416号重庆日报集团传媒大厦24楼</p>
            <p>咨询电话：023-65031293 &nbsp; 13368263300</p>
          </div>
        </div>
        <!-- 右侧：导航链接 + 二维码 -->
        <div class="footer-right">
          <div class="footer-nav-grid">
            <div class="footer-nav-col">
              <router-link to="/" class="nav-standalone">首页</router-link>
            </div>
            <div class="footer-nav-col">
              <router-link to="/mall" class="nav-standalone">商城</router-link>
            </div>
            <div class="footer-nav-col">
              <h4>研究院</h4>
              <router-link to="/institute">兰台简介</router-link>
            </div>
            <div class="footer-nav-col">
              <h4>新闻动态</h4>
              <router-link to="/news?type=指示精神">指示精神</router-link>
              <router-link to="/news?type=工作动态">工作动态</router-link>
              <router-link to="/news?type=行业资讯">行业资讯</router-link>
            </div>
            <div class="footer-nav-col">
              <h4>项目研究</h4>
              <router-link to="/project">项目研究</router-link>
            </div>
            <div class="footer-nav-col">
              <h4>兰台研读</h4>
              <router-link to="/volume?category=1">教学计划</router-link>
              <router-link to="/volume?category=2">课程规划</router-link>
              <router-link to="/volume?category=3">课程</router-link>
              <router-link to="/volume?category=4">专家</router-link>
              <router-link to="/volume?category=5">师资</router-link>
            </div>
            <div class="footer-nav-col">
              <h4>政策法规</h4>
              <router-link to="/policy?type=政策解读">政策解读</router-link>
              <router-link to="/policy?type=法律规章">法律规章</router-link>
              <router-link to="/policy?type=行业标准">行业标准</router-link>
            </div>
            <div class="footer-nav-col">
              <router-link to="/talent" class="nav-standalone">人才招聘</router-link>
            </div>
          </div>
          <div class="footer-qrcodes">
            <div class="qrcode">
              <img src="../assets/footright1.png" alt="二维码1" />
              <p>扫码关注公众号</p>
            </div>
            <div class="qrcode">
              <img src="../assets/footright2.png" alt="二维码2" />
              <p>扫码关注公众号</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部版权栏 -->
    <div class="footer-bottom">
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">
        重庆市兰台档案研究院ICP备案：渝ICP备2022006051号-1
      </a>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter'
}
</script>

<style scoped>
/* ========== 桌面端（>1200px）========== */
.site-footer {
  background: transparent;
  color: #8b4513;
}

.footer-main {
  background: #fdf3ea;
  width: 79.17%;
  max-width: 1520px;
  margin: 0 auto;
  padding: 40px 0 30px;
  box-sizing: border-box;
}

.footer-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 40px;
  padding: 0 27px;
  box-sizing: border-box;
}

.footer-info {
  flex-shrink: 0;
  min-width: 280px;
}

.footer-logo-row {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  margin-bottom: 20px;
}

.footer-logo-text {
  font-size: 22px;
  font-weight: 700;
  color: #8b4513;
  letter-spacing: 2px;
  white-space: nowrap;
}

.footer-logo-en {
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 1px;
}

.footer-contact p {
  font-size: 14px;
  color: #8b4513;
  line-height: 2;
  margin: 0;
}

.footer-right {
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 30px;
}

.footer-nav-grid {
  display: flex;
  gap: 60px;
  align-items: flex-start;
}

.footer-nav-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.footer-nav-col h4 {
  font-size: 14px;
  font-weight: 600;
  color: #ad634a;
  margin: 0 0 6px;
  white-space: nowrap;
  text-align: center;
}

.nav-standalone {
  font-size: 14px;
  font-weight: 600;
  color: #ad634a;
  text-decoration: none;
  white-space: nowrap;
  display: block;
  text-align: center;
}

.nav-standalone:hover {
  color: #8b4513;
}

.footer-nav-col a {
  font-size: 13px;
  color: #8b4513;
  text-decoration: none;
  line-height: 1.8;
  white-space: nowrap;
  text-align: center;
}

.footer-nav-col a:hover {
  color: #ad634a;
}

.footer-qrcodes {
  display: flex;
  gap: 15px;
  flex-shrink: 0;
}

.qrcode {
  text-align: center;
}

.qrcode img {
  width: 100px;
  height: 100px;
  border-radius: 4px;
}

.qrcode p {
  color: #8b4513;
  font-size: 12px;
  margin-top: 6px;
}

.footer-bottom {
  background: #ecb68a;
  text-align: center;
  padding: 14px 0;
  width: 79.17%;
  max-width: 1520px;
  margin: 0 auto;
  box-sizing: border-box;
}

.footer-bottom a {
  color: #fff;
  font-size: 13px;
  text-decoration: none;
}

.footer-bottom a:hover {
  text-decoration: underline;
}

/* ========== 1200px - 等比缩小 ========== */
@media (max-width: 1200px) {
  .footer-main {
    padding: 30px 0 24px;
  }

  .footer-container {
    gap: 30px;
    padding: 0 20px;
  }

  .footer-info {
    min-width: 200px;
  }

  .footer-logo-text {
    font-size: 18px;
    letter-spacing: 1px;
  }

  .footer-logo-en {
    font-size: 12px;
  }

  .footer-logo-row {
    margin-bottom: 16px;
    gap: 2px;
  }

  .footer-contact p {
    font-size: 13px;
    line-height: 1.8;
  }

  .footer-right {
    gap: 20px;
  }

  .footer-nav-grid {
    gap: 35px;
  }

  .footer-nav-col h4 {
    font-size: 13px;
    margin-bottom: 4px;
  }

  .nav-standalone {
    font-size: 13px;
  }

  .footer-nav-col a {
    font-size: 12px;
    line-height: 1.6;
  }

  .qrcode img {
    width: 85px;
    height: 85px;
  }

  .qrcode p {
    font-size: 11px;
    margin-top: 4px;
  }

  .footer-bottom {
    padding: 12px 0;
  }

  .footer-bottom a {
    font-size: 12px;
  }
}

/* ========== 768px - 小屏竖排布局 ========== */
@media (max-width: 768px) {
  .footer-main {
    width: 100%;
    max-width: 100%;
    padding: 28px 16px 20px;
  }

  .footer-container {
    flex-direction: column;
    gap: 24px;
    padding: 0;
  }

  .footer-info {
    min-width: 0;
  }

  .footer-logo-text {
    font-size: 18px;
    letter-spacing: 1px;
    white-space: normal;
  }

  .footer-logo-en {
    font-size: 11px;
    white-space: normal;
  }

  .footer-logo-row {
    margin-bottom: 14px;
    gap: 2px;
  }

  .footer-contact p {
    font-size: 12px;
    line-height: 1.8;
  }

  /* 导航和二维码竖排 */
  .footer-right {
    flex-direction: column;
    gap: 24px;
  }

  /* 导航用flex自动换行 */
  .footer-nav-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 16px 24px;
  }

  .footer-nav-col {
    min-width: 60px;
  }

  .footer-nav-col h4 {
    font-size: 13px;
    white-space: nowrap;
  }

  .nav-standalone {
    font-size: 13px;
    white-space: nowrap;
  }

  .footer-nav-col a {
    font-size: 12px;
    white-space: nowrap;
    line-height: 1.6;
  }

  /* 二维码居中 */
  .footer-qrcodes {
    justify-content: center;
    flex-shrink: 1;
  }

  .qrcode img {
    width: 90px;
    height: 90px;
  }

  .qrcode p {
    font-size: 11px;
    margin-top: 4px;
  }

  .footer-bottom {
    width: 100%;
    max-width: 100%;
    padding: 12px 0;
  }

  .footer-bottom a {
    font-size: 11px;
  }
}

/* ========== 480px - 手机 ========== */
@media (max-width: 480px) {
  .footer-main {
    padding: 20px 12px 16px;
  }

  .footer-container {
    gap: 18px;
  }

  .footer-logo-text {
    font-size: 16px;
  }

  .footer-logo-en {
    font-size: 10px;
  }

  .footer-contact p {
    font-size: 11px;
    line-height: 1.6;
  }

  .footer-nav-grid {
    gap: 12px 16px;
  }

  .footer-nav-col {
    min-width: 50px;
  }

  .footer-nav-col h4 {
    font-size: 12px;
  }

  .nav-standalone {
    font-size: 12px;
  }

  .footer-nav-col a {
    font-size: 11px;
    line-height: 1.5;
  }

  .qrcode img {
    width: 75px;
    height: 75px;
  }

  .qrcode p {
    font-size: 10px;
  }

  .footer-bottom {
    padding: 10px 0;
  }

  .footer-bottom a {
    font-size: 10px;
  }
}
</style>
